import { Helmet } from "react-helmet-async";

export default function Seo({ title, canonical, noindex = false }) {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {canonical && <link rel="canonical" href={canonical} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
    </Helmet>
  );
}
